(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var timers = new WeakMap();

  function setOpen(details, open) {
    clearTimeout(timers.get(details));
    details.open = open;
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.querySelectorAll('.header__inline-menu header-menu details').forEach(function (details) {
    details.addEventListener('mouseenter', function () {
      if (mq.matches) setOpen(details, true);
    });
    details.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      timers.set(details, setTimeout(function () { setOpen(details, false); }, 180));
    });
    details.addEventListener('focusout', function (event) {
      if (mq.matches && !details.contains(event.relatedTarget)) setOpen(details, false);
    });
    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setOpen(details, false);
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  });
})();
